import LookupLecturerClassesRequestModelBase from '../_generated/modelBases/lookup-lecturer-classes-request-model-base';

export default class LookupLecturerClassesRequestModel extends LookupLecturerClassesRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
